import styled from 'styled-components'

export const PendCards = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #80808066;
  border: 0.5px solid #dfdfdf;
  border-radius: 16px;
  padding: 5px 1.5rem 5px 1.5rem;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height:68px;
  @media (max-width: 770px) {
    padding: 10px 0px;

  }
`;

export const PendItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 770px){
    padding-left: 10px;
  }

  @media(max-width: 439px){
    flex-direction: column;
  }
`;

export const PendTitle = styled.div`
  display: flex;
  align-items: center;

  p{
    margin-bottom: 0px;
    color: #000FFF;

    @media (max-width: 992px) {
      line-height: 1.1;
    }
  }
`

export const Details = styled.div`
  background-color: #000FFF;
  position: relative;
  right: -1.5rem;
  color: white;
  padding: 0.15rem 1rem;
  border-bottom-left-radius: 0.8rem;
  border-top-left-radius: 0.8rem;
  height: 1.3rem;
  width: 96px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 500px) {
    right: -0.4rem;
    padding: 0.2rem 0 0.2rem 0.4rem;
  }

  @media (min-width: 768px) {
    font-size: 0.6rem !important;
    padding: 0.15rem 0.2rem;
   img{
      width: 14%;
    }
  }

  @media (min-width: 800px) {
    font-size: 0.6rem;
    padding: 0.15rem 0.4rem;
   img{
      width: 18%;
    }
  }

  @media (min-width: 850px) {
    font-size: 0.7rem !important;
    padding: 0.15rem 0.5rem;
   img{
      width: 18%;
    }
  }

  @media (min-width: 900px) {
    font-size: 0.7rem !important;
    padding: 0.15rem 0.5rem;
   img{
      width: 18%;
    }
  }

  @media (max-width: 770px) {
    width: 113px;
    font-size: 13px;
    padding: 0 18px !important;
    right: 0px;
    height: auto;
  }

  @media(max-width: 439px){
    margin-top: 10px;
    align-self:flex-end;
  }
`;

